var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{ref:"occTableContainer",staticClass:"occ-table",class:[
    ("occ-table-" + _vm.type),
    ("occ-table-" + _vm.type + "--" + _vm.size),
    { 'occ-table--fixed': _vm.fixed },
    _vm.scroll && ("occ-table-" + _vm.type + "--scroll")
  ],style:(_vm.styles),on:{"scroll":_vm.handleScroll}},[(_vm.$slots.header)?_c('thead',{class:[
      ("occ-table-" + _vm.type + "__thead"),
      ("occ-table-" + _vm.type + "--" + _vm.size + "__thead"),
      _vm.scroll && ("occ-table-" + _vm.type + "__thead--fix-head"),
      _vm.hideHeader && ("occ-table-" + _vm.type + "__thead--hide-header")
    ]},[_vm._t("header")],2):_vm._e(),(_vm.$slots.body)?_c('tbody',{class:[
      ("occ-table-" + _vm.type + "__tbody"),
      ("occ-table-" + _vm.type + "--" + _vm.size + "__tbody"),
      _vm.hideBottomBorder && ("occ-table-" + _vm.type + "__tbody--hide-bottom-border")
    ]},[_vm._t("body")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }